export default "__VITE_ASSET__Bw1Z$VJa__"